// Security Controls PDF Generator - Mesures de contrôle Report
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import { normalizeRuleStatus, getRuleStatusLabelFr } from './ruleStatusNormalizer.js';

const STRINGS = {
    fr: {
        title: 'Rapport Atelier 1 - Mesures de contrôle',
        subject: 'EBIOS RM - Atelier 1 - Mesures de contrôle',
        author: 'Système EBIOS RM',
        creator: 'Générateur de Rapport Sécurité Controls EBIOS RM',
        keywords: 'EBIOS RM, Atelier 1, Mesures de contrôle, Sécurité, Risques',
        analysisId: 'Id de l\'analyse',
        analysisName: 'Nom de l\'analyse',
        companyName: 'Nom de l\'entreprise',
        version: '1.0',
        reference: 'EBIOSRM_ATELIER1_CONTROLS',
        createdBy: 'Système EBIOS RM',
        lastModified: new Date().toLocaleDateString('fr-FR'),
        status: 'Finalisé',
        reportType: 'Atelier 1 - Mesures de contrôle',
        controlsCount: (n) => `${n || 0} définies`,
        programme: 'Programme',
        organisation: 'Organisation',
        classification: 'Classification',
        revisionFrequency: 'Fréquence de révision',
        statusLabel: 'Statut',
        controlsLabel: 'Mesures de contrôle',
        generationDate: 'Date de génération',
        headerProgramme: 'Programme :',
        headerAnalysis: 'Analyse des risques – EBIOS RM',
        classificationInterne: 'Interne',
        documentType: 'Document :',
        rapportTitle: 'Rapport Atelier 1 - Mesures de contrôle',
        versionLabel: 'Version :',
        referenceLabel: 'Réf :',
        mainTitle: 'Rapport d\'Analyse de Risques:',
        companyTitle: 'EBIOS RM - Atelier 1',
        controlsSectionTitle: 'Mesures de contrôle',
        historyHeaders: ['Version', 'Date', 'Description, remarques', 'Auteur', 'Vérificateur', 'Approbateur'],
        version: '1.0',
        initialDescription: 'Rapport initial Mesures de contrôle - Atelier 1',
        footerText: 'Méthodologie EBIOS RM - Atelier 1: Mesures de Contrôle',
        confidentiality: 'Document confidentiel - Usage interne uniquement',
        footerConfidential: 'Document confidentiel - Usage interne uniquement',
        pageHeader: 'Rapport Atelier 1 - Mesures de contrôle',
        sectionOverview: '1. VUE D\'ENSEMBLE DES MESURES DE CONTRÔLE',
        introductionText: (n) => `Ce document présente le plan de traitement des risques avec les mesures de contrôle définies durant l'Atelier 1 de la méthodologie EBIOS Risk Manager. ${n} mesure${n > 1 ? 's' : ''} de contrôle ${n > 1 ? 'ont' : 'a'} été définie${n > 1 ? 's' : ''}.`,
        decisionImplemented: 'Mise en œuvre',
        decisionPartial: 'Partielle',
        decisionPlanned: 'Planifiée',
        decisionApplyBefore: 'À appliquer avant',
        decisionAbandoned: 'Abandonnée',
        decisionNotSpecified: 'Non spécifié',
        minor: 'Mineure (G1)',
        moderate: 'Modérée (G2)',
        major: 'Majeure (G3)',
        critical: 'Critique (G4)',
        catastrophic: 'Catastrophique (G5)',
        progressBarBackground: [229, 231, 235],
        progressBarFilled: (color) => `rgba(${color.join(', ')}, 1)`,
        tableColumnHeaders: ['Règle / Événement', 'Statut d\'applicabilité', 'Commentaire sur l\'écart', 'Justification', 'Gravité', 'Mesures de contrôle', 'Gravité résiduelle'],
        tableLandscapeColumnHeaders: ['Règle / Événement', 'Statut d\'applicabilité', 'Commentaire sur l\'écart', 'Justification', 'Gravité', 'Mesures de contrôle', 'Gravité résiduelle'],
        controlNamePrefix: 'Contrôle ',
        orphanDEName: 'Événement',
        noDELabel: '—',
        reportGenerated: 'Rapport PDF généré avec succès',
        reportError: 'Erreur lors de la génération du PDF',
        pageNumber: 'Page ',
        footerDocument: 'Rapport EBIOS RM',
        footerConfidential: 'Confidentiel - Usage interne',
        coverPageTitle: 'Rapport d\'Analyse de Risques:',
        coverSubtitle: 'EBIOS RM - Atelier 1',
        overviewSectionTitle: '1.1. Distribution par Décision d\'Implémentation',
        residualSeverityLabel: 'Sévérité résiduelle',
        emptyState: '—'
    },
    en: {
        title: 'Workshop 1 Report - Security Controls',
        subject: 'EBIOS RM - Workshop 1 - Security Controls',
        author: 'EBIOS RM System',
        creator: 'EBIOS RM Security Controls Report Generator',
        keywords: 'EBIOS RM, Workshop 1, Security Controls, Risks',
        analysisId: 'Analysis ID',
        analysisName: 'Analysis Name',
        companyName: 'Company Name',
        version: '1.0',
        reference: 'EBIOSRM_WORKSHOP1_CONTROLS',
        createdBy: 'EBIOS RM System',
        lastModified: new Date().toLocaleDateString('en-GB'),
        status: 'Finalized',
        reportType: 'Workshop 1 - Security Controls',
        controlsCount: (n) => `${n || 0} defined`,
        programme: 'Programme',
        organisation: 'Organization',
        classification: 'Classification',
        revisionFrequency: 'Annual / Every major change',
        statusLabel: 'Status',
        controlsLabel: 'Security Controls',
        generationDate: 'Generation Date',
        headerProgramme: 'Programme :',
        headerAnalysis: 'Risk Analysis – EBIOS RM',
        classificationInternal: 'Internal',
        documentType: 'Document :',
        rapportTitle: 'Workshop 1 Report - Security Controls',
        versionLabel: 'Version :',
        referenceLabel: 'Ref :',
        mainTitle: 'Risk Analysis Report:',
        companyTitle: 'EBIOS RM - Workshop 1',
        controlsSectionTitle: 'Security Controls',
        historyHeaders: ['Version', 'Date', 'Description, notes', 'Author', 'Reviewer', 'Approver'],
        version: '1.0',
        initialDescription: 'Initial Control Plan Report - Workshop 1',
        footerText: 'EBIOS RM Methodology - Workshop 1: Security Controls',
        confidentiality: 'Confidential Document - Internal Use Only',
        pageHeader: 'Workshop 1 Report - Security Controls',
        sectionOverview: '1. SECURITY CONTROLS OVERVIEW',
        introductionText: (n) => `This document presents the risk treatment plan with the security controls defined during Workshop 1 of the EBIOS Risk Manager methodology. ${n} control${n !== 1 ? 's have' : ' has'} been defined.`,
        decisionImplemented: 'Implemented',
        decisionPartial: 'Partial',
        decisionPlanned: 'Planned',
        decisionApplyBefore: 'Apply Before',
        decisionAbandoned: 'Abandoned',
        decisionNotSpecified: 'Not specified',
        minor: 'Minor (G1)',
        moderate: 'Moderate (G2)',
        major: 'Major (G3)',
        critical: 'Critical (G4)',
        catastrophic: 'Catastrophic (G5)',
        progressBarBackground: [229, 231, 235],
        progressBarFilled: (color) => `rgba(${color.join(', ')}, 1)`,
        tableColumnHeaders: ['Rule / Event', 'Severity In.', 'Controls', 'Severity Res.'],
        tableLandscapeColumnHeaders: ['Rule / Event', 'Severity In.', 'Controls', 'Severity Res.', 'Decision', 'Control Type', 'Residual Severity'],
        controlNamePrefix: 'Control ',
        orphanDEName: 'Event',
        noDELabel: '—',
        reportGenerated: 'PDF Report (EN) generated successfully',
        reportError: 'Error generating PDF (EN)',
        pageNumber: 'Page ',
        footerDocument: 'EBIOS RM Report',
        footerConfidential: 'Confidential - Internal Use',
        coverPageTitle: 'Risk Analysis Report:',
        coverSubtitle: 'EBIOS RM - Workshop 1',
        overviewSectionTitle: '1.1. Distribution by Implementation Decision',
        residualSeverityLabel: 'Residual Severity',
        emptyState: '—'
    }
};

class SecurityControlsPdfGenerator {
    constructor(controlPlanData = {}, analysisData = {}, securityFrameworkData = {}, dreadedEventsData = [], lang = 'fr') {
        this.lang = lang;
        this.T = STRINGS[lang] || STRINGS.fr;
        this.controlPlanData = controlPlanData || {};
        this.analysisData = analysisData || {};
        this.securityFrameworkData = securityFrameworkData || {};
        this.dreadedEventsData = dreadedEventsData || [];

        // Initialize simple jsPDF instance
        this.pdf = new jsPDF('p', 'mm', 'a4');

        // Set PDF metadata
        this.pdf.setProperties({
            title: 'Rapport Atelier 1 - Mesures de Contr\u00f4le',
            subject: 'EBIOS RM - Atelier 1 - Mesures de Contr\u00f4le',
            author: 'Syst\u00e8me EBIOS RM',
            creator: 'EBIOS RM Security Controls Report Generator',
            keywords: 'EBIOS RM, Atelier 1, Mesures de Contr\u00f4le, Security Controls, S\u00e9curit\u00e9, Risques'
        });

// Set analysis metadata for cover page
        this.metadata = {
            analysisId: this.analysisData.id || 'N/A',
            analysisName: this.analysisData.name || this.analysisData.analysisName || 'Analyse EBIOS RM',
            companyName: this.analysisData.companyName || this.analysisData.organizationName || 'Organisation',
            version: '1.0',
            reference: 'EBIOSRM_ATELIER1_CONTROLS',
            createdBy: this.analysisData.createdBy || 'Système EBIOS RM',
            lastModified: new Date().toLocaleDateString('fr-FR'),
            status: 'Finalisé',
            reportType: 'Atelier 1 - Mesures de contrôle',
            controlsCount: this.countTotalControls()
        };

        // Decision labels and colors
        this.decisionLabels = {
            implemented: this.T.decisionImplemented,
            partial: this.T.decisionPartial,
            planned: this.T.decisionPlanned,
            apply_before: this.T.decisionApplyBefore,
            abandoned: this.T.decisionAbandoned,
            'not-specified': this.T.decisionNotSpecified
        };

        this.decisionColors = {
            'implemented': [34, 197, 94],      // Green
            'partial': [251, 191, 36],         // Yellow
            'planned': [59, 130, 246],         // Blue
            'apply_before': [249, 115, 22],    // Orange
            'abandoned': [239, 68, 68],         // Red
            'not-specified': [128, 128, 128]    // Gray
        };

        // Severity labels and colors
        this.severityLabels = {
            minor: this.T.minor,
            moderate: this.T.moderate,
            major: this.T.major,
            critical: this.T.critical,
            catastrophic: this.T.catastrophic
        };

        this.severityColors = {
            'minor': [103, 232, 249],          // Cyan
            'moderate': [253, 230, 138],       // Light yellow
            'major': [245, 158, 11],           // Yellow
            'critical': [220, 38, 38],         // Red
            'catastrophic': [0, 0, 0]          // Black
        };
    }

    /**
     * Count total controls across all rule-event pairs
     */
    countTotalControls() {
        const plan = this.controlPlanData.planData?.plan || {};
        let total = 0;
        Object.values(plan).forEach(entry => {
            if (entry.controls && Array.isArray(entry.controls)) {
                total += entry.controls.length;
            }
        });
        return total;
    }

    /**
     * Generate Security Controls Cover Page
     */
    generateCoverPage() {
        const pageWidth = this.pdf.internal.pageSize.getWidth();
        const pageHeight = this.pdf.internal.pageSize.getHeight();

        // Clean white background
        this.pdf.setFillColor(255, 255, 255);
        this.pdf.rect(0, 0, pageWidth, pageHeight, 'F');

        // Header table - Programme info
        this.pdf.setFillColor(255, 255, 255);
        this.pdf.setDrawColor(0, 0, 0);
        this.pdf.setLineWidth(0.5);
        this.pdf.rect(15, 15, 180, 10, 'S');

        this.pdf.setFontSize(9);
        this.pdf.setFont('helvetica', 'bold');
        this.pdf.text('Programme :', 17, 21);
        this.pdf.setFont('helvetica', 'normal');
        this.pdf.text('Analyse des risques – EBIOS RM', 45, 21);

        // Internal classification label
        this.pdf.setFillColor(200, 200, 200);
        this.pdf.rect(135, 15, 60, 10, 'FD');
        this.pdf.setTextColor(0, 0, 0);
        this.pdf.setFont('helvetica', 'bold');
        this.pdf.text('Interne', 155, 21);
        this.pdf.setTextColor(0, 0, 0);

        // Document type
        this.pdf.setFillColor(255, 255, 255);
        this.pdf.rect(15, 25, 180, 8, 'S');
        this.pdf.setFont('helvetica', 'bold');
        this.pdf.text('Document :', 17, 30);
        this.pdf.setFont('helvetica', 'normal');
        this.pdf.text('Rapport Atelier 1 - Mesures de Contr\u00f4le', 45, 30);

        // Version and Reference
        this.pdf.rect(15, 33, 90, 8, 'S');
        this.pdf.setFont('helvetica', 'bold');
        this.pdf.text('Version :', 17, 38);
        this.pdf.setFont('helvetica', 'normal');
        this.pdf.text(this.metadata.version || '1.0', 37, 38);

        this.pdf.rect(105, 33, 90, 8, 'S');
        this.pdf.setFont('helvetica', 'bold');
        this.pdf.text('R\u00e9f :', 107, 38);
        this.pdf.setFont('helvetica', 'normal');
        this.pdf.text(this.metadata.reference || 'EBIOSRM_ATELIER1_CONTROLS', 120, 38);

        // Main title
        this.pdf.setFontSize(18);
        this.pdf.setFont('helvetica', 'bold');
        this.pdf.setTextColor(37, 99, 235);
        this.pdf.text('Rapport d\'Analyse de Risques:', 105, 65, { align: 'center' });

        this.pdf.setFontSize(18);
        const maxTW = this.pdf.internal.pageSize.getWidth() - 30;
        const companyName = `${this.metadata.companyName}`;
        const al = this.pdf.splitTextToSize(companyName, maxTW);
        al.forEach((line, i) => this.pdf.text(line, 105, 80 + i * 7, { align: 'center' }));
        const extraY = (al.length - 1) * 7;

        // EBIOS RM title
        this.pdf.setFontSize(24);
        this.pdf.setTextColor(37, 99, 235);
        this.pdf.text('EBIOS RM - Atelier 1', 105, 110 + extraY, { align: 'center' });

        // Security Controls section
        this.pdf.setFontSize(16);
        this.pdf.setTextColor(16, 185, 129); // Green for security controls
        this.pdf.text('Mesures de Contr\u00f4le', 105, 135 + extraY, { align: 'center' });
        this.pdf.setTextColor(0, 0, 0);

        // Information table
        const tableStartY = 150 + extraY;
        const rowHeight = 8;

        const tableData = [
            ['Programme', 'Atelier 1 - P\u00e9rim\u00e8tre et socle de s\u00e9curit\u00e9'],
            ['Organisation', this.metadata.companyName || 'Non sp\u00e9cifi\u00e9'],
            ['Classification', 'Interne'],
            ['Fr\u00e9quence de r\u00e9vision', 'Annuelle / chaque changement majeur'],
            ['Statut', 'Compl\u00e9t\u00e9'],
            ['Mesures de contr\u00f4le', `${this.metadata.controlsCount || 0} d\u00e9finies`],
            ['Date de g\u00e9n\u00e9ration', new Date().toLocaleDateString('fr-FR')]
        ];

        tableData.forEach((row, index) => {
            const y = tableStartY + (index * rowHeight);

            // Label column (blue background)
            this.pdf.setFillColor(41, 82, 163);
            this.pdf.rect(15, y, 65, rowHeight, 'FD');
            this.pdf.setTextColor(255, 255, 255);
            this.pdf.setFontSize(9);
            this.pdf.setFont('helvetica', 'bold');
            this.pdf.text(row[0], 17, y + 5.5);

            // Value column (light gray background)
            this.pdf.setFillColor(235, 235, 235);
            this.pdf.rect(80, y, 115, rowHeight, 'FD');
            this.pdf.setTextColor(0, 0, 0);
            this.pdf.setFont('helvetica', 'normal');

            // Handle long text
            const maxWidth = 110;
            const lines = this.pdf.splitTextToSize(row[1], maxWidth);
            if (lines.length > 1) {
                const truncated = row[1].length > 50 ? row[1].substring(0, 47) + '...' : row[1];
                this.pdf.text(truncated, 82, y + 5.5);
            } else {
                this.pdf.text(row[1], 82, y + 5.5);
            }
        });

        // Version history table
        const historyY = 215;
        const headerHeight = 10;
        const dataRowHeight = 15;

        const headers = ['Version', 'Date', 'Description, remarques', 'Auteur', 'V\u00e9rificateur', 'Approbateur'];
        const colWidths = [18, 22, 70, 30, 20, 20];
        let xPos = 15;

        // Draw header row
        headers.forEach((header, i) => {
            this.pdf.setFillColor(41, 82, 163);
            this.pdf.setDrawColor(0, 0, 0);
            this.pdf.setLineWidth(0.5);
            this.pdf.rect(xPos, historyY, colWidths[i], headerHeight, 'FD');

            this.pdf.setTextColor(255, 255, 255);
            this.pdf.setFontSize(7);
            this.pdf.setFont('helvetica', 'bold');

            const maxHeaderWidth = colWidths[i] - 3;
            const headerLines = this.pdf.splitTextToSize(header, maxHeaderWidth);
            const startY = historyY + (headerHeight / 2) - ((headerLines.length - 1) * 1.5);

            headerLines.forEach((line, lineIndex) => {
                this.pdf.text(line, xPos + 1.5, startY + (lineIndex * 3));
            });

            xPos += colWidths[i];
        });

        // Add data row
        xPos = 15;
        const versionData = [
            this.metadata.version || '1.0',
            new Date().toLocaleDateString('fr-FR'),
            'Rapport initial Mesures de Contr\u00f4le - Atelier 1',
            '',
            '',
            ''
        ];

        versionData.forEach((data, i) => {
            this.pdf.setFillColor(245, 245, 245);
            this.pdf.setDrawColor(0, 0, 0);
            this.pdf.setLineWidth(0.5);
            this.pdf.rect(xPos, historyY + headerHeight, colWidths[i], dataRowHeight, 'FD');

            this.pdf.setTextColor(0, 0, 0);
            this.pdf.setFontSize(7);
            this.pdf.setFont('helvetica', 'normal');

            if (data) {
                const maxColWidth = colWidths[i] - 3;
                const lines = this.pdf.splitTextToSize(data, maxColWidth);
                const maxLines = Math.floor((dataRowHeight - 2) / 3);
                const displayLines = lines.slice(0, maxLines);

                if (lines.length > maxLines && displayLines.length > 0) {
                    let truncatedLine = displayLines[displayLines.length - 1];
                    const ellipsisWidth = this.pdf.getTextWidth('...');
                    const availableWidth = maxColWidth - ellipsisWidth;

                    while (this.pdf.getTextWidth(truncatedLine) > availableWidth && truncatedLine.length > 0) {
                        truncatedLine = truncatedLine.slice(0, -1);
                    }
                    displayLines[displayLines.length - 1] = truncatedLine + '...';
                }

                const startY = historyY + headerHeight + (dataRowHeight / 2) - ((displayLines.length - 1) * 1.5);
                displayLines.forEach((line, lineIndex) => {
                    this.pdf.text(line, xPos + 1.5, startY + (lineIndex * 3));
                });
            }
            xPos += colWidths[i];
        });

        // Footer
        const footerY = pageHeight - 20;
        this.pdf.setFontSize(8);
        this.pdf.setTextColor(107, 114, 128);
        this.pdf.setFont('helvetica', 'normal');
        this.pdf.text(this.T.footerText, 105, footerY, { align: 'center' });
        this.pdf.text(this.T.footerConfidential, 105, footerY + 8, { align: 'center' });
    }

    /**
     * Start new content page with clean background
     */
    startNewPage(orientation = 'p') {
        this.pdf.addPage('a4', orientation);
        const pageWidth = this.pdf.internal.pageSize.getWidth();
        const pageHeight = this.pdf.internal.pageSize.getHeight();

        // White background
        this.pdf.setFillColor(255, 255, 255);
        this.pdf.rect(0, 0, pageWidth, pageHeight, 'F');
    }

    /**
     * Add professional page headers and footers to all pages
     */
    addPageNumbers() {
        const pageCount = this.pdf.internal.getNumberOfPages();

        for (let i = 1; i <= pageCount; i++) {
            this.pdf.setPage(i);


            // Skip header/footer on cover page
            if (i === 1) continue;

            const pageWidth = this.pdf.internal.pageSize.getWidth();
            const pageHeight = this.pdf.internal.pageSize.getHeight();

            // === PAGE HEADER ===
            const headerY = 15;

            // Header line
            this.pdf.setDrawColor(229, 231, 235);
            this.pdf.setLineWidth(0.5);
            this.pdf.line(20, headerY + 5, pageWidth - 20, headerY + 5);

            // Document title on left
            this.pdf.setFontSize(8);
            this.pdf.setTextColor(107, 114, 128);
            this.pdf.setFont('helvetica', 'normal');
            this.pdf.text('Rapport Atelier 1 - Mesures de Contr\u00f4le', 20, headerY);

            // Section name on right
            let sectionName = '';
            if (i === 2) {
                sectionName = 'Vue d\'ensemble';
            } else if (i >= 3) {
                sectionName = 'Plan de traitement';
            }

            if (sectionName) {
                this.pdf.text(sectionName, pageWidth - 20, headerY, { align: 'right' });
            }

            // === PAGE FOOTER ===
            const footerY = pageHeight - 10;

            // Footer line
            this.pdf.setDrawColor(229, 231, 235);
            this.pdf.setLineWidth(0.5);
            this.pdf.line(20, footerY - 5, pageWidth - 20, footerY - 5);

            // Left: Document info
            this.pdf.setFontSize(8);
            this.pdf.setTextColor(107, 114, 128);
            this.pdf.setFont('helvetica', 'normal');
            this.pdf.text('Rapport EBIOS RM', 20, footerY);

            // Center: Confidentiality notice
            const centerText = 'Confidentiel - Usage interne';
            this.pdf.text(centerText, pageWidth / 2, footerY, { align: 'center' });

            // Right: Page number
            this.pdf.text(`Page ${i}`, pageWidth - 20, footerY, { align: 'right' });
        }
    }

    /**
     * Generate security controls overview section
     */
    generateOverviewSection() {
        const pageWidth = this.pdf.internal.pageSize.getWidth();
        let currentY = 30;

        // Section title
        this.pdf.setFontSize(18);
        this.pdf.setTextColor(30, 64, 175);
        this.pdf.setFont('helvetica', 'bold');
        this.pdf.text('1. VUE D\'ENSEMBLE DES MESURES DE CONTR\u00d4LE', 20, currentY);
        currentY += 15;

        // Introduction
        this.pdf.setFontSize(10);
        this.pdf.setTextColor(51, 65, 85);
        this.pdf.setFont('helvetica', 'normal');

        const introText = `Ce document pr\u00e9sente le plan de traitement des risques avec les mesures de contr\u00f4le d\u00e9finies ` +
            `durant l'Atelier 1 de la m\u00e9thodologie EBIOS Risk Manager. ${this.metadata.controlsCount} mesure${this.metadata.controlsCount > 1 ? 's' : ''} de contr\u00f4le ${this.metadata.controlsCount > 1 ? 'ont' : 'a'} \u00e9t\u00e9 d\u00e9finie${this.metadata.controlsCount > 1 ? 's' : ''}.`;

        const introLines = this.pdf.splitTextToSize(introText, 170);
        introLines.forEach(line => {
            this.pdf.text(line, 20, currentY);
            currentY += 6;
        });
        currentY += 15;

        // Statistics
        const plan = this.controlPlanData.planData?.plan || {};
        const decisionStats = {};
        let pairsWithControls = 0;

        Object.entries(plan).forEach(([key, entry]) => {
            // Count pairs with controls
            if (entry.controls && entry.controls.length > 0) {
                pairsWithControls++;

                // Count by decision
                entry.controls.forEach(control => {
                    const decision = control.decision || 'not-specified';
                    decisionStats[decision] = (decisionStats[decision] || 0) + 1;
                });
            }
        });

        // Decision distribution
        if (Object.keys(decisionStats).length > 0) {
            this.pdf.setFontSize(14);
            this.pdf.setTextColor(30, 64, 175);
            this.pdf.setFont('helvetica', 'bold');
            this.pdf.text('1.1. Distribution par D\u00e9cision d\'Impl\u00e9mentation', 20, currentY);
            currentY += 12;

            Object.entries(decisionStats).forEach(([decision, count]) => {
                const decisionLabel = this.decisionLabels[decision] || decision;
                const decisionColor = this.decisionColors[decision] || [100, 100, 100];
                const percentage = Math.round((count / this.metadata.controlsCount) * 100);

                // Decision badge
                this.pdf.setFillColor(...decisionColor);
                this.pdf.circle(25, currentY - 1.5, 2, 'F');

                this.pdf.setFontSize(10);
                this.pdf.setTextColor(51, 65, 85);
                this.pdf.setFont('helvetica', 'bold');
                this.pdf.text(decisionLabel, 30, currentY);

                // Count and percentage
                this.pdf.setFont('helvetica', 'normal');
                this.pdf.text(`${count} mesure${count > 1 ? 's' : ''} (${percentage}%)`, 100, currentY);

                // Progress bar
                const barWidth = 60;
                const barHeight = 5;
                const barX = 140;
                const barY = currentY - 4;
                const fillWidth = (barWidth * percentage) / 100;

                // Background bar
                this.pdf.setFillColor(229, 231, 235);
                this.pdf.roundedRect(barX, barY, barWidth, barHeight, 1, 1, 'F');

                // Filled bar
                if (fillWidth > 0) {
                    this.pdf.setFillColor(...decisionColor);
                    this.pdf.roundedRect(barX, barY, fillWidth, barHeight, 1, 1, 'F');
                }

                currentY += 10;
            });

            currentY += 10;
        }
    }

    /**
     * Generate detailed control plan section
     */
    generateControlPlanSection() {
        const plan = this.controlPlanData.planData?.plan || {};
        const ruleLinks = this.securityFrameworkData?.ruleDreadedEvents || {};
        const allRules = Object.values(this.securityFrameworkData?.selectedRules || {}).flat();
        const ruleGapComments = this.securityFrameworkData?.ruleGapComments || {};

        // Build rule-ID to rule object map
        const ruleMap = {};
        allRules.forEach(r => { ruleMap[String(r.id || r.rule_id)] = r; });

        // Build pairs from ruleDreadedEvents (same logic as SecurityControls.js linkedPairs)
        const pairs = [];
        for (const [ruleIdStr, linkedDeIds] of Object.entries(ruleLinks)) {
            const rule = ruleMap[ruleIdStr];
            if (!rule || !Array.isArray(linkedDeIds)) continue;
            linkedDeIds.forEach(deId => {
                if (deId === '__v') return; // skip placeholder sentinel
                const de = this._findDreadedEvent(deId) || { id: deId, name: `Événement ${deId}` };
                pairs.push({ rule, de });
            });
        }

        // Add orphan rules (no linked DE at all in ruleDreadedEvents) with a sentinel DE
        const pairedRuleIds = new Set(pairs.map(p => String(p.rule?.id)));
        allRules.forEach(rule => {
            const ruleId = rule?.id && String(rule.id);
            if (ruleId && !pairedRuleIds.has(ruleId)) {
                const linkedDeIds = ruleLinks[ruleId];
                if (!linkedDeIds || linkedDeIds.length === 0 || (linkedDeIds.length === 1 && linkedDeIds[0] === '__v')) {
                    pairs.push({
                        rule,
                        de: { id: null, name: null, severity: null, businessValue: '' }
                    });
                }
            }
        });

        if (pairs.length === 0) return;

        // Sort by rule name (natural order: 5.7, 5.8, 5.10)
        pairs.sort((a, b) => {
            const nA = (a.rule?.name || String(a.rule?.id || '')).toLowerCase();
            const nB = (b.rule?.name || String(b.rule?.id || '')).toLowerCase();
            return nA.localeCompare(nB, undefined, { numeric: true });
        });

        // Split into ER (scenario) and non-intentional
        const isNonInt = (p) => {
            if (p.de?.businessValue === '__global__') return true;
            if (p.de?.id != null) {
                const fullDe = this._findDreadedEvent(p.de.id);
                if (fullDe?.businessValue === '__global__') return true;
            }
            return false;
        };
        const erPairs = pairs.filter(p => !isNonInt(p));
        const niPairs = pairs.filter(p => isNonInt(p));

        const headers = [
          'Règle / Événement',
          'Statut\nd\'applicabilité',
          'Commentaire\nsur l\'écart',
          'Justification',
          'Gravité',
          'Mesures de Contrôle',
          'Gravité\nRésiduelle'
        ];

        const buildRows = (pairList) => pairList.map(({ rule, de }) => {
            const isOrphan = de?.id == null;
            const deIdPart = isOrphan ? '__no_de__' : de.id;
            const pairKey = `${rule.id}_${deIdPart}`;
            const entry = plan[pairKey] || {};
            const ruleName = rule?.name || rule?.title || `Règle ${rule.id}`;
            const eventName = de?.name || '';

            // Rule applicability status
            const statusLevel = normalizeRuleStatus(rule?.status);
            const statusLabel = getRuleStatusLabelFr(statusLevel);

            // Gap comment with event/risk label
            const rawGap = ruleGapComments[rule?.id] || '';
            const deLabel = isOrphan ? '' : (de?.businessValue === '__global__' ? 'Risque non intentionnel' : 'Événement redouté');
            const gapComment = isOrphan
                ? (rawGap || '—')
                : (rawGap
                    ? `Commentaire : ${rawGap}\n\n${deLabel} : ${eventName}`
                    : `${deLabel} : ${eventName}`);

            // Rule justification
            const justification = rule?.justification || '—';

            const initialSeverity = de?.severity
                ? (this.severityLabels[de.severity] || de.severity)
                : (isOrphan ? '—' : '-');
            const residualSeverity = this.severityLabels[entry.residualSeverity] || entry.residualSeverity || '-';

            let controlsWithDetails = '-';
            if (entry.controls && entry.controls.length > 0) {
                const formattedControls = entry.controls.map(c => {
                    const controlName = c.name || `Contrôle ${c.controlId?.substring(0, 8)}`;
                    let lines = [`- ${controlName}`, ''];
                    if (c.decision) {
                        const decisionLabel = this.decisionLabels[c.decision] || c.decision;
                        let dt = `  • Décision: ${decisionLabel}`;
                        if (c.decision === 'apply_before' && c.decisionDate) dt += ` (${c.decisionDate})`;
                        lines.push(dt);
                    }
                    if (c.responsiblePerson && c.responsiblePerson !== '-') {
                        lines.push(`  • Responsable: ${c.responsiblePerson}`);
                    }
                    return lines.join('\n');
                });
                controlsWithDetails = formattedControls.join('\n\n\n');
            }
            return [
                `${ruleName}\n${eventName}`,
                statusLabel,
                gapComment,
                justification,
                initialSeverity,
                controlsWithDetails,
                residualSeverity
            ];
        });

        const tableBase = {
            theme: 'grid',
            margin: { top: 30, bottom: 20, left: 15, right: 15 },
            headStyles: { fillColor: [16, 185, 129], textColor: [255, 255, 255], fontSize: 7, fontStyle: 'bold', halign: 'center' },
            styles: { fontSize: 6, cellPadding: 1.5, lineColor: [226, 232, 240], lineWidth: 0.5, overflow: 'linebreak' },
            alternateRowStyles: { fillColor: [248, 250, 252] },
            columnStyles: {
                0: { cellWidth: 30 },
                1: { cellWidth: 18 },
                2: { cellWidth: 24 },
                3: { cellWidth: 24 },
                4: { cellWidth: 16 },
                5: { cellWidth: 38 },
                6: { cellWidth: 16 }
            }
        };

        const tableBaseLandscape = {
            theme: 'grid',
            margin: { top: 30, bottom: 20, left: 15, right: 15 },
            headStyles: { fillColor: [16, 185, 129], textColor: [255, 255, 255], fontSize: 7, fontStyle: 'bold', halign: 'center' },
            styles: { fontSize: 6, cellPadding: 1.5, lineColor: [226, 232, 240], lineWidth: 0.5, overflow: 'linebreak' },
            alternateRowStyles: { fillColor: [248, 250, 252] },
            columnStyles: {
                0: { cellWidth: 50 },
                1: { cellWidth: 25 },
                2: { cellWidth: 45 },
                3: { cellWidth: 45 },
                4: { cellWidth: 20 },
                5: { cellWidth: 60 },
                6: { cellWidth: 20 }
            }
        };

        // Table 1: Scenario risks (ER)
        if (erPairs.length > 0) {
            this.startNewPage('l');
            let currentY = 30;
            this.pdf.setFontSize(18);
            this.pdf.setTextColor(30, 64, 175);
            this.pdf.setFont('helvetica', 'bold');
            this.pdf.text('2.1. MESURES DE CONTROLE (RISQUES INTENTIONNELS)', 20, currentY);
            currentY += 15;
            this.pdf.autoTable({ ...tableBaseLandscape, startY: currentY, head: [headers], body: buildRows(erPairs) });
        }

        // Table 2: Non-intentional risks
        if (niPairs.length > 0) {
            this.startNewPage('l');
            let currentY = 30;
            this.pdf.setFontSize(18);
            this.pdf.setTextColor(30, 64, 175);
            this.pdf.setFont('helvetica', 'bold');
            this.pdf.text('2.2. MESURES DE CONTROLE (RISQUES NON INTENTIONNELS)', 20, currentY);
            currentY += 15;
            this.pdf.autoTable({ ...tableBaseLandscape, startY: currentY, head: [headers], body: buildRows(niPairs) });
        }
    }

    /**
     * Generate professional security controls PDF report
     * @returns {Promise<Blob>} PDF blob
     */
    async generateSecurityControlsReport() {
        try {
            console.log('[SecurityControlsPdfGenerator] Starting PDF generation');

            // Page 1: Cover Page
            this.generateCoverPage();

            // Page 2: Overview
            this.startNewPage();
            this.generateOverviewSection();

            // Page 3+: Control Plan
            this.generateControlPlanSection();

            // Add headers and footers to all pages
            this.addPageNumbers();

            console.log('[SecurityControlsPdfGenerator] PDF generation completed');
            return this.getBlob();

        } catch (error) {
            console.error('[SecurityControlsPdfGenerator] Error generating PDF:', error);
            throw error;
        }
    }

    _findDreadedEvent(deId) {
        if (!deId) return null;
        const id = String(deId);
        const suffix = id.includes('-') ? id.split('-').slice(1).join('-') : null;
        return this.dreadedEventsData.find(de => {
            const dId = String(de.id);
            return dId === id ||
                String(de._id) === id ||
                dId.endsWith(id) ||
                (suffix && (dId === suffix || dId.endsWith(suffix)));
        }) || null;
    }

    /**
     * Get PDF as blob
     * @returns {Blob} PDF blob
     */
    getBlob() {
        return this.pdf.output('blob');
    }

    /**
     * Download PDF
     * @param {string} filename - PDF filename
     */
    download(filename = 'mesures-de-controle.pdf') {
        this.pdf.save(filename);
    }
}

export default SecurityControlsPdfGenerator;
